var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPathGondola(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 3C35.6 3 45 12.4 45 24C45 35.6 35.6 45 24 45C12.4 45 3 35.6 3 24C3 12.4 12.4 3 24 3ZM24 0C10.7 0 0 10.7 0 24C0 37.3 10.7 48 24 48C37.3 48 48 37.3 48 24C48 10.7 37.3 0 24 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9231 11.7024C26.9231 13.0027 26.9231 14.5368 26.9231 15.3534C26.9231 15.6643 26.8779 16.0126 26.7676 16.3563C26.6024 16.8663 26.306 17.3629 25.7792 17.79H28.1131L28.1516 17.7235C28.5849 16.9128 28.7373 16.0764 28.7378 15.3534C28.7378 14.5594 28.7378 13.085 28.7378 11.8091C28.7378 11.5921 28.7378 11.3848 28.7378 11.184L30.559 10.6635L29.7979 8L24.6956 9.45845L25.4567 12.1215L26.9231 11.7024Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8234 18.8332H18.777C16.9048 18.8332 14.4708 23.2303 14.4708 27.4168C14.4708 31.6034 16.9048 36 18.777 36H29.8234C31.6957 36 34.1297 31.6034 34.1297 27.4169C34.1297 23.2303 31.6957 18.8332 29.8234 18.8332ZM16.9115 28.691C16.8516 28.2746 16.8149 27.8484 16.8149 27.4169C16.8149 24.4238 18.4342 21.6389 19.1581 21.3164H23.0669V28.691H16.9115ZM31.689 28.691H25.1083V21.3164H29.4425C30.1664 21.6389 31.7856 24.4238 31.7856 27.4169C31.7856 27.8484 31.7489 28.2746 31.689 28.691Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2203 10.5034L13 13.4233L13.4487 14.9939L23.669 12.0739L23.2203 10.5034Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathGondola);
export default __webpack_public_path__ + "static/media/path-gondola.0e5bc29ef980ac80f1df6876230421a8.svg";
export { ForwardRef as ReactComponent };